// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1LD3P","select":"Header_select__1WvZ1","clinic":"Header_clinic__1yVC6"};